<template>
  <div class="table-container">
    <!-- 搜索栏（固定） -->
    <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
      <!-- 电脑端使用 Element UI 搜索框 -->
      <div v-if="isDesktop" class="desktop-search-wrapper">
        <div class="search-row">
          <el-input 
            v-model="searchKeyword" 
            placeholder="请输入关键词搜索" 
            clearable
            size="small"
            class="search-input"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <div class="button-group">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus" 
              @click="handleAdd"
              class="add-button"
            >
              添加素材
            </el-button>
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-filter" 
              @click="toggleFilter"
              class="filter-button"
            >
              {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
            </el-button>
          </div>
        </div>
        
        <!-- 电脑端筛选面板 -->
        <div v-if="isDesktop && isFilterOpen" class="filter-panel">
          <div class="filter-row">
            <div class="filter-item">
              <label>场所：</label>
              <el-select v-model="params.temple_id" placeholder="请选择场所" clearable size="small" style="width: 150px;">
                <el-option :value="0" label="官方"></el-option>
                <el-option
                  v-for="(value,key) in temple"
                  filterable
                  :key="key"
                  :label="value.name"
                  :value="value.id">
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>分类：</label>
              <el-select v-model="params.religious_type" placeholder="请选择分类" clearable size="small" style="width: 150px;">
                <el-option
                  v-for="(value,key) in religiousTypeList"
                  :key="key"
                  :label="value.label"
                  :value="value.value">
                  <div style="width:100%;display:inline-flex;align-items:center;">
                    <el-image style="width:20px;height: 20px;" :src="value.icon"></el-image>
                    <span style="margin-left: 10px;">{{value.label}}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>状态：</label>
              <el-select v-model="params.status" placeholder="请选择状态" clearable size="small" style="width: 120px;">
                <el-option
                  v-for="(value,key) in statusList"
                  :key="key"
                  :label="value.label"
                  :value="value.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="filter-actions">
            <div class="applied-filters">
              <span v-if="params.temple_id" class="filter-tag">
                场所: {{ params.temple_id === 0 ? '官方' : (temple.find(item => item.id === params.temple_id) ? temple.find(item => item.id === params.temple_id).name : params.temple_id) }}
              </span>
              <span v-if="params.religious_type" class="filter-tag">
                分类: {{ religiousTypeList.find(item => item.value === params.religious_type) ? religiousTypeList.find(item => item.value === params.religious_type).label : params.religious_type }}
              </span>
              <span v-if="params.status" class="filter-tag">
                状态: {{ statusList.find(item => item.value === params.status) ? statusList.find(item => item.value === params.status).label : params.status }}
              </span>
              <span v-if="!params.temple_id && !params.religious_type && !params.status && !params.is_share" class="filter-tag filter-tag-empty">
                当前无筛选条件
              </span>
            </div>
            <div class="filter-buttons">
              <el-button size="small" @click="resetFilter">重置筛选</el-button>
              <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 手机端使用 Vant 搜索框 -->
      <div v-else class="mobile-search-wrapper">
        <van-search
          v-model="searchKeyword"
          placeholder="请输入关键词搜索"
          show-action
          @search="handleSearch"
          @cancel="onSearchCancel"
          :placeholder-style="{ fontSize: '16px' }"
          :input-align="'center'"
        >
          <template #action>
            <div @click="handleSearch" style="margin-right: 10px; font-size: 16px; color: var(--primary); font-weight: 600;">搜索</div>
          </template>
        </van-search>
        
        <!-- 手机端添加按钮 -->
        <div class="mobile-add-button">
          <van-button 
            type="primary" 
            size="small" 
            block
            icon="plus"
            @click="handleAdd"
            style="margin-top: 10px;"
          >
            添加素材
          </van-button>
        </div>
        
        <!-- 手机端筛选面板 -->
        <div v-if="isFilterOpen" class="mobile-filter-panel">
          <!-- 手机端已应用筛选条件显示 -->
          <div class="mobile-applied-filters">
            <div v-if="appliedFilterForm.temple_id || appliedFilterForm.religious_type || appliedFilterForm.status || appliedFilterForm.is_share" class="applied-title">已应用筛选条件：</div>
            <div class="applied-tags">
              <span v-if="appliedFilterForm.temple_id" class="mobile-filter-tag">
                场所: {{ appliedFilterForm.temple_id === 0 ? '官方' : (temple.find(item => item.id === appliedFilterForm.temple_id) ? temple.find(item => item.id === appliedFilterForm.temple_id).name : appliedFilterForm.temple_id) }}
              </span>
              <span v-if="appliedFilterForm.religious_type" class="mobile-filter-tag">
                分类: {{ religiousTypeList.find(item => item.value === appliedFilterForm.religious_type) ? religiousTypeList.find(item => item.value === appliedFilterForm.religious_type).label : appliedFilterForm.religious_type }}
              </span>
              <span v-if="appliedFilterForm.status" class="mobile-filter-tag">
                状态: {{ statusList.find(item => item.value === appliedFilterForm.status) ? statusList.find(item => item.value === appliedFilterForm.status).label : appliedFilterForm.status }}
              </span>
              <span v-if="!appliedFilterForm.temple_id && !appliedFilterForm.religious_type && !appliedFilterForm.status && !appliedFilterForm.is_share" class="mobile-filter-tag empty">
                当前无筛选条件
              </span>
            </div>
          </div>
          
          <van-cell title="场所" is-link @click="showTemplePicker = true">{{ filterForm.temple_id === 0 ? '官方' : (temple.find(item => item.id === filterForm.temple_id) ? temple.find(item => item.id === filterForm.temple_id).name : '全部') }}</van-cell>
          <van-cell title="分类" is-link @click="showReligiousPicker = true">{{ religiousTypeList.find(item => item.value === filterForm.religious_type) ? religiousTypeList.find(item => item.value === filterForm.religious_type).label : '全部' }}</van-cell>
          <van-cell title="状态" is-link @click="showStatusPicker = true">{{ statusList.find(item => item.value === filterForm.status) ? statusList.find(item => item.value === filterForm.status).label : '全部' }}</van-cell>
          <div class="mobile-filter-actions">
            <van-button type="default" size="small" @click="resetFilter">重置</van-button>
            <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
          </div>
        </div>
        
        <!-- 手机端筛选展开按钮 -->
        <div class="mobile-filter-toggle" @click="toggleFilter">
          <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" /> 
          <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
        </div>
      </div>
    </div>
    
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      <div class="library-content" ref="libraryContent" style="margin-top: 20px;">
        <!-- 电脑端标签页 -->
        <el-tabs v-model="params.file_type" v-if="isDesktop">
          <el-tab-pane label="图片" name="0">
            <div class="image-box box">
              <div class="library-flow">
                <div class="library-item" v-for="(value,key) in filteredList" :key="key">
                  <img :src="value.src" :alt="value.name" @click="handleImageClick(key)" style="cursor: pointer;" />
                  <div class="item-name">{{ value.name }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="书籍" name="1">
            <div class="book-box box">
              
            </div>
          </el-tab-pane>
          <el-tab-pane label="音乐" name="2">
            <div class="music-box box">
              
            </div>
          </el-tab-pane>
          <el-tab-pane label="视频" name="3">
            <div class="video-box box">
              
            </div>
          </el-tab-pane>
        </el-tabs>
        
        <!-- 手机端标签页 -->
        <van-tabs v-model="params.file_type" v-else>
          <van-tab title="图片" name="0">
            <div class="mobile-image-box">
                <van-grid :column-num="2" :border="false">
                  <van-grid-item v-for="(value, key) in filteredList" :key="key">
                    <div class="mobile-library-item">
                      <van-image
                        :src="value.src"
                        fit="cover"
                        style="width: 100%; height: 120px; cursor: pointer;"
                        @click="handleImageClick(key)"
                      />
                      <div class="mobile-item-name">{{ value.name }}</div>
                    </div>
                  </van-grid-item>
                </van-grid>
              </div>
          </van-tab>
          <van-tab title="书籍" name="1">
            <div class="mobile-book-box">
              <div class="empty-tips">
                <van-empty description="暂无书籍数据" />
              </div>
            </div>
          </van-tab>
          <van-tab title="音乐" name="2">
            <div class="mobile-music-box">
              <div class="empty-tips">
                <van-empty description="暂无音乐数据" />
              </div>
            </div>
          </van-tab>
          <van-tab title="视频" name="3">
            <div class="mobile-video-box">
              <div class="empty-tips">
                <van-empty description="暂无视频数据" />
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    
    <!-- 手机端选择器弹窗 -->
    <van-popup v-model="showTemplePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="mobileTempleOptions"
        @confirm="onTempleConfirm"
        @cancel="showTemplePicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showReligiousPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="mobileReligiousOptions"
        @confirm="onReligiousConfirm"
        @cancel="showReligiousPicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showStatusPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="mobileStatusOptions"
        @confirm="onStatusConfirm"
        @cancel="showStatusPicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showSharePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="mobileShareOptions"
        @confirm="onShareConfirm"
        @cancel="showSharePicker = false"
      />
    </van-popup>
    
    <!-- 电脑端图片预览弹窗 -->
    <el-dialog
      v-if="isDesktop && previewVisible"
      :visible.sync="previewVisible"
      title="图片预览"
      :close-on-click-modal="true"
      width="90%"
      :fullscreen="true"
      center
    >
      <div class="desktop-image-preview">
        <div class="preview-toolbar">
          <div class="preview-info">
            {{ previewIndex + 1 }} / {{ previewList.length }}
          </div>
          <div class="preview-actions">
            <el-button size="small" @click="handlePrevImage" icon="el-icon-arrow-left"></el-button>
            <el-button size="small" @click="zoomOut" icon="el-icon-zoom-out">{{ zoomLevel.toFixed(1) }}x</el-button>
            <el-button size="small" @click="resetZoom">重置</el-button>
            <el-button size="small" @click="zoomIn" icon="el-icon-zoom-in"></el-button>
            <el-button size="small" @click="handleNextImage" icon="el-icon-arrow-right"></el-button>
          </div>
        </div>
        <div class="preview-content">
          <img 
            ref="previewImage" 
            :src="currentPreviewSrc" 
            :style="previewImageStyle" 
            @wheel="handleWheel" 
            @mousedown="handleMouseDown"
            @mousemove="handleMouseMove"
            @mouseup="handleMouseUp"
            @mouseleave="handleMouseUp"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let page_name="library"
import {getListSelect} from "@/api/temple.js"
import { ImagePreview } from 'vant'
export default {
  name: "library",
  data() {
    return {
      isDesktop: undefined,
      col:0,
      date: [],
      temple:[],
      searchKeyword: '',
      // 筛选相关
      isFilterOpen: false,
      // 筛选表单（未应用的筛选条件）
      filterForm: {
        temple_id: '',
        religious_type: '',
        status: '',
        is_share: ''
      },
      // 已应用的筛选条件
      appliedFilterForm: {
        temple_id: '',
        religious_type: '',
        status: '',
        is_share: ''
      },
      // 手机端选择器
      showTemplePicker: false,
      showReligiousPicker: false,
      showStatusPicker: false,
      showSharePicker: false,
      // 图片预览相关
      previewVisible: false,
      previewIndex: 0,
      previewList: [],
      // 电脑端预览相关
      zoomLevel: 1,
      maxZoom: 3,
      minZoom: 0.5,
      panX: 0,
      panY: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
      startPanX: 0,
      startPanY: 0,
      fileTypeList:[
        {value:0,label:'图片'},
        {value:1,label:'书籍'},
        {value:2,label:'音乐'},
        {value:3,label:'视频'},
      ],
      religiousTypeList:[
        {value:0,label:'佛家',icon:'https://cdn.cxc-group.com/manage/fo-festival-icon.png'},
        {value:1,label:'道家',icon:'https://cdn.cxc-group.com/manage/dao-festival-icon.png'},
        {value:2,label:'传统',icon:'https://cdn.cxc-group.com/manage/normal-festival-icon.png'},
      ],
      statusList:[
        {value:0,label:'下架'},
        {value:1,label:'上架'},
      ],
      shareList:[
        {value:0,label:'独立'},
        {value:1,label:'共享'},
      ],
      list:[
        {id:1,src:"https://img1.baidu.com/it/u=3889466524,1327489668&fm=253&fmt=auto&app=138&f=JPEG",name:"元宵汤圆国风国潮矢量故宫传统文化插画背景",type:2,temple_name:'官方'},
        {id:2,src:"https://pic4.zhimg.com/v2-27b00d01d2cbcdbfd600abb3d02281d7_r.jpg",name:"传统文化囚牛壁纸",type:2,temple_name:'官方'},
        {id:3,src:"https://img0.baidu.com/it/u=1277821593,318833320&fm=253&fmt=auto&app=138&f=JPEG",name:"国风手机壁纸传统文化《道藏·上清骨髓灵文鬼律》记载：北极驱邪院印的多种规格制式。睡得安稳，行的端正",type:1,temple_name:'官方'},
        {id:5,src:"https://img2.baidu.com/it/u=1417102897,1864319839&fm=253&fmt=auto&app=138&f=JPEG",name:"观世音佛像",type:0,temple_name:'官方'},
        {id:6,src:"https://img.zcool.cn/community/012c725d5d0178a8012187f4e9c2fc.jpg?x-oss-process=image/auto-orient,1/resize,m_lfit,w_1280,limit_1/sharpen,100",name:"观音",type:0,temple_name:'官方'},
        {id:7,src:"https://img2.baidu.com/it/u=3847484273,3544946149&fm=253&fmt=auto&app=138&f=JPEG",name:"佛佑众生",type:0,temple_name:'官方'},
        {id:8,src:"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fitem%2F201504%2F07%2F20150407H5014_uXH8z.thumb.400_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1725762991&t=2d9cc25e700898d8e55f24430d84a824",name:"佛说生死",type:0,temple_name:'官方'},
        {id:9,src:"https://img0.baidu.com/it/u=2255508329,326416167&fm=253&fmt=auto&app=138&f=JPEG",name:"我心向佛",type:0,temple_name:'官方'},
        {id:10,src:"https://pica.zhimg.com/v2-8defe9bd56743b9fe937f122fafa100f_r.jpg?source=1940ef5c",name:"道",type:1,temple_name:'官方'},
        {id:11,src:"https://img2.baidu.com/it/u=3549995625,2520681505&fm=253&fmt=auto&app=138&f=JPEG",name:"道符壁纸",type:1,temple_name:'官方'},
        {id:12,src:"https://img0.baidu.com/it/u=3826993468,469012222&fm=253&fmt=auto&app=138&f=JPEG",name:"乾为天",type:1,temple_name:'官方'},
        {id:13,src:"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage109.360doc.com%2FDownloadImg%2F2019%2F01%2F1810%2F152273576_4_20190118103055994&refer=http%3A%2F%2Fimage109.360doc.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1725763335&t=ed2e60f872ceb5522636d66514e7ab02",name:"动善时",type:0,temple_name:'官方'},
        {id:14,src:"https://e0.ifengimg.com/06/2018/1119/01F2767B52D9BF13D1947B5678E387F14F307815_size140_w1920_h1080.jpg",name:"八卦",type:1,temple_name:'官方'},
      ],
      params:{
        temple_id:'',
        file_type:0,
        religious_type:'',
        status:'',
        is_share:''
      }
    };
  },
  computed: {
    // 过滤后的列表
    filteredList() {
      return this.list.filter(item => {
        // 关键词搜索
        const keyword = this.searchKeyword.toLowerCase()
        const matchesKeyword = !keyword || 
                             item.name.toLowerCase().includes(keyword) ||
                             item.temple_name.toLowerCase().includes(keyword)
        
        // 场所筛选
        const matchesTemple = !this.params.temple_id || (this.params.temple_id === 0 ? item.temple_name === '官方' : true)
        
        // 分类筛选
        const matchesReligious = !this.params.religious_type || item.type === this.params.religious_type
        
        // 状态筛选 - 暂时没有状态字段，默认匹配
        const matchesStatus = true
        
        // 共享状态筛选 - 暂时没有共享状态字段，默认匹配
        const matchesShare = true
        
        return matchesKeyword && matchesTemple && matchesReligious && matchesStatus && matchesShare
      })
    },
    // 当前预览图片地址
    currentPreviewSrc() {
      return this.previewList[this.previewIndex]
    },
    // 预览图片样式
    previewImageStyle() {
      return {
        transform: `scale(${this.zoomLevel}) translate(${this.panX}px, ${this.panY}px)`,
        transition: this.isDragging ? 'none' : 'transform 0.2s ease',
        cursor: this.isDragging ? 'grabbing' : 'grab',
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain'
      }
    },
    // 手机端场所选项
    mobileTempleOptions() {
      let options = ['全部', '官方'];
      this.temple.forEach(item => {
        options.push(item.name);
      });
      return options;
    },
    // 手机端宗教类型选项
    mobileReligiousOptions() {
      return ['全部', ...this.religiousTypeList.map(item => item.label)];
    },
    // 手机端状态选项
    mobileStatusOptions() {
      return ['全部', ...this.statusList.map(item => item.label)];
    },
    // 手机端共享状态选项
    mobileShareOptions() {
      return ['全部', ...this.shareList.map(item => item.label)];
    }
  },

  created(){
    // 初始化时就检查屏幕尺寸，确保isDesktop变量在组件挂载之前就已经被正确设置
    this.checkScreenSize()
  },
  mounted(){
    let that = this
    let width = this.$refs.libraryContent ? this.$refs.libraryContent.offsetWidth : 0
    this.getCol(width)
    window.onresize = () => {
      this.checkScreenSize()
      if(this.$refs.libraryContent) {
        this.getCol(this.$refs.libraryContent.offsetWidth)
      }
    }
    this.getSelectOptions()
  },

  methods: {
    // 检查屏幕尺寸，判断是否为桌面端
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768;
    },
    getSelectOptions(){
      this.getTemple()
    },
    getCol(width) {
      if (width > 1580) {
        this.col = 5;
      } else if (1024 < width && width < 1580) {
        this.col = 4;
      } else if (768 < width && width < 1024) {
        this.col = 2;
      } else {
        this.col = 2;
      }
    },
    getTemple() {
      getListSelect().then(res=>{
        if(res.code === 200){
          this.temple = res.data
        }
      })
    },
    // 图片点击事件，显示预览
    handleImageClick(index) {
      // 准备预览列表
      this.previewList = this.filteredList.map(item => item.src);
      this.previewIndex = index;
      
      if (this.isDesktop) {
        // 电脑端使用Element UI的Dialog预览
        this.zoomLevel = 1;
        this.panX = 0;
        this.panY = 0;
        this.previewVisible = true;
      } else {
        // 手机端使用vant的ImagePreview
        ImagePreview({
          images: this.previewList,
          startPosition: this.previewIndex,
          showIndex: true,
          loop: true,
          enableZoom: true,
          maxZoom: 3,
          minZoom: 0.5
        })
      }
    },
    // 电脑端预览：上一张
    handlePrevImage() {
      this.previewIndex = (this.previewIndex - 1 + this.previewList.length) % this.previewList.length;
      this.resetPan();
    },
    // 电脑端预览：下一张
    handleNextImage() {
      this.previewIndex = (this.previewIndex + 1) % this.previewList.length;
      this.resetPan();
    },
    // 电脑端预览：放大
    zoomIn() {
      if (this.zoomLevel < this.maxZoom) {
        this.zoomLevel += 0.1;
      }
    },
    // 电脑端预览：缩小
    zoomOut() {
      if (this.zoomLevel > this.minZoom) {
        this.zoomLevel -= 0.1;
      }
    },
    // 电脑端预览：重置缩放和位置
    resetZoom() {
      this.zoomLevel = 1;
      this.resetPan();
    },
    // 重置平移位置
    resetPan() {
      this.panX = 0;
      this.panY = 0;
    },
    // 电脑端预览：鼠标滚轮事件
    handleWheel(event) {
      event.preventDefault();
      const delta = event.deltaY > 0 ? -0.1 : 0.1;
      const newZoomLevel = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoomLevel + delta));
      
      // 计算鼠标在图片上的位置
      const rect = this.$refs.previewImage.getBoundingClientRect();
      const mouseX = event.clientX - rect.left - rect.width / 2;
      const mouseY = event.clientY - rect.top - rect.height / 2;
      
      // 计算缩放中心
      const scaleRatio = newZoomLevel / this.zoomLevel;
      this.panX = mouseX - (mouseX - this.panX) * scaleRatio;
      this.panY = mouseY - (mouseY - this.panY) * scaleRatio;
      this.zoomLevel = newZoomLevel;
    },
    // 电脑端预览：鼠标按下事件
    handleMouseDown(event) {
      if (this.zoomLevel > 1) {
        this.isDragging = true;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.startPanX = this.panX;
        this.startPanY = this.panY;
      }
    },
    // 电脑端预览：鼠标移动事件
    handleMouseMove(event) {
      if (this.isDragging) {
        const deltaX = event.clientX - this.startX;
        const deltaY = event.clientY - this.startY;
        this.panX = this.startPanX + deltaX;
        this.panY = this.startPanY + deltaY;
      }
    },
    // 电脑端预览：鼠标释放事件
    handleMouseUp() {
      this.isDragging = false;
    },
    // 搜索
    handleSearch() {
      console.log('搜索:', this.searchKeyword);
    },
    // 手机端搜索取消
    onSearchCancel() {
      this.searchKeyword = '';
    },
    // 手机端添加素材
    handleAdd() {
      console.log('添加素材');
    },
    // 切换筛选面板
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
    },
    // 应用筛选
    applyFilter() {
      // 保存已应用的筛选条件
      this.appliedFilterForm = { ...this.filterForm };
      
      // 更新params
      this.params = {
        ...this.params,
        keyword: this.searchKeyword,
        temple_id: this.filterForm.temple_id,
        religious_type: this.filterForm.religious_type,
        status: this.filterForm.status,
        is_share: this.filterForm.is_share,
        page: 1
      };
      
      this.isFilterOpen = false;
      this.fetchData();
      console.log('应用筛选:', this.params);
    },
    // 重置筛选
    resetFilter() {
      // 重置筛选表单
      this.filterForm = {
        temple_id: '',
        religious_type: '',
        status: '',
        is_share: ''
      };
      
      // 重置已应用筛选条件
      this.appliedFilterForm = {
        temple_id: '',
        religious_type: '',
        status: '',
        is_share: ''
      };
      
      // 更新params
      this.params = {
        ...this.params,
        temple_id: '',
        religious_type: '',
        status: '',
        is_share: '',
        page: 1
      };
      
      this.isFilterOpen = false;
      this.fetchData();
      console.log('重置筛选');
    },
    // 手机端场所选择确认
    onTempleConfirm(value) {
      if (value === '全部') {
        this.filterForm.temple_id = '';
      } else if (value === '官方') {
        this.filterForm.temple_id = 0;
      } else {
        const templeItem = this.temple.find(item => item.name === value);
        this.filterForm.temple_id = templeItem ? templeItem.id : '';
      }
      this.showTemplePicker = false;
    },
    // 手机端分类选择确认
    onReligiousConfirm(value) {
      if (value === '全部') {
        this.filterForm.religious_type = '';
      } else {
        const religiousItem = this.religiousTypeList.find(item => item.label === value);
        this.filterForm.religious_type = religiousItem ? religiousItem.value : '';
      }
      this.showReligiousPicker = false;
    },
    // 手机端状态选择确认
    onStatusConfirm(value) {
      if (value === '全部') {
        this.filterForm.status = '';
      } else {
        const statusItem = this.statusList.find(item => item.label === value);
        this.filterForm.status = statusItem ? statusItem.value : '';
      }
      this.showStatusPicker = false;
    },
    // 手机端共享状态选择确认
    onShareConfirm(value) {
      if (value === '全部') {
        this.filterForm.is_share = '';
      } else {
        const shareItem = this.shareList.find(item => item.label === value);
        this.filterForm.is_share = shareItem ? shareItem.value : '';
      }
      this.showSharePicker = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/static/default";

/* 使用全局样式中定义的 CSS 变量 */
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 搜索栏（固定） */
.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 手机端搜索置顶 */
.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.search-container h2 {
  margin-bottom: 20px;
  color: var(--text);
}

/* 电脑端搜索容器 */
.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.filter-button {
  white-space: nowrap;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
}

.add-button {
  white-space: nowrap;
}

/* 手机端添加按钮样式 */
.mobile-add-button {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 筛选操作区域 */
.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

/* 已应用筛选标签容器 */
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 单个筛选标签样式 */
.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

/* 空状态筛选标签 */
.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 筛选按钮容器 */
.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 手机端已应用筛选条件样式 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-applied-filters .applied-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.mobile-applied-filters .applied-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 手机端筛选操作按钮区域 */
.mobile-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  background-color: var(--background);
}

/* 手机端搜索容器 */
.mobile-search-wrapper {
  width: 100%;
}

.mobile-search-container {
  margin-bottom: 15px;
}

/* 手机端筛选面板 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
}

/* 手机端筛选展开按钮 */
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
}

.container {
  width: 100%;
  height: 100%;
  background-color: #fff !important;
  box-sizing: border-box;
  padding: 20px;
  padding-bottom: 0;
  display: inline-flex;
  flex-flow: column;
  justify-content: space-between;
}
.library-content{
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.box{
  width: 100%;
  min-height: 590px;
}

// 电脑端流式布局
.library-flow {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 10px 0;
}

.library-item {
  flex: 0 0 calc(20% - 12.8px);
  box-sizing: border-box;
  transition: all 0.3s ease;
  cursor: pointer;
}

.library-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.library-item img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
}

.item-name {
  margin-top: 8px;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

// 响应式流式布局调整
@media (max-width: 1580px) {
  .library-item {
    flex: 0 0 calc(25% - 12px);
  }
}

@media (max-width: 1024px) {
  .library-item {
    flex: 0 0 calc(33.333% - 10.666px);
  }
}

@media (max-width: 768px) {
  .library-item {
    flex: 0 0 calc(50% - 8px);
  }
}

// 手机端样式
.mobile-image-box,
.mobile-book-box,
.mobile-music-box,
.mobile-video-box {
  padding: 10px;
}

.mobile-library-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}

.mobile-library-item .van-image {
  width: 100%;
  height: 120px;
  border-radius: 4px;
}

.mobile-library-item .van-image__img {
  object-fit: cover;
}

.mobile-item-name {
  margin-top: 8px;
  font-size: 12px;
  color: #333;
  text-align: center;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0 4px;
}

.empty-tips {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

// 响应式设计
@media (max-width: 768px) {
  .search-container h2 {
    margin-bottom: 15px;
  }
  
  .search-container .search-input {
    display: none;
  }
  
  .content-container {
    padding: 10px 0;
  }
  
  .search-input {
    max-width: 100%;
  }
  
  .container {
    padding: 10px;
  }
  
  .library-content {
    height: calc(100% - 40px);
  }
  
  .box {
    min-height: auto;
  }
  
  .library-flow {
    gap: 10px;
  }
  
  .library-item img {
    height: 120px;
  }
  
  .item-name {
    font-size: 12px;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .search-container{
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }
  .van-search{
    padding:0;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .filter-item {
    width: 100%;
  }
  
  .filter-item .el-select,
  .filter-item .el-input-number {
    width: 100% !important;
  }
}

@media (min-width: 769px) {
  .search-container .mobile-search-wrapper,
  .mobile-filter-toggle {
    display: none;
  }
}

/* 电脑端图片预览样式 */
.desktop-image-preview {
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.preview-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid #e8e8e8;
  z-index: 10;
}

.preview-info {
  font-size: 16px;
  font-weight: 500;
}

.preview-actions {
  display: flex;
  gap: 10px;
}

.preview-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #f5f5f5;
  position: relative;
}

.preview-content img {
  user-select: none;
  touch-action: none;
}
</style>
<style scoped>
::-webkit-scrollbar {
    display: none;
}
</style>